module.exports = __webpack_public_path__ + "img/vet-contact.208f3860.svg";